import React from "react";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs/components/prism-core";

import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism.css";
import helper from "../../../utils/helper";

export default function Codec({ value, setValue, isTemplate }) {
    const lines = (value || "").split("\n");

    return (
        <div className="hdv-form-default">
            <div className="label-with-info">
                <label className="required label-truncate">Script Decoder</label>
                <i
                    className="fa fa-info-circle fa-15px"
                    title='Informações sobre a linguagem de script decoder'
                    style={{ cursor: "pointer", marginTop: '9px' }}
                    onClick={() =>
                        helper.dispatchEvent("showAviso", {
                            message: "No seu script de decoder utilize a linguagem JavaScript",
                        })
                    }
                />
            </div>

            <div className="codec-editor-wrapper">
                <div className="codec-editor-line-numbers">
                    {lines.map((_, i) => (
                        <div key={i}>{i + 1}</div>
                    ))}
                </div>

                <Editor
                    value={value || ""}
                    onValueChange={setValue}
                    highlight={(code) => highlight(code, languages.javascript)}
                    padding={10}
                    textareaClassName="editor-textarea"
                    style={{
                        flex: 1,
                        fontFamily: '"Fira Code", monospace',
                        fontSize: 12,
                    }}
                    placeholder='Digite aqui seu script decoder em JavaScript'
                    disabled={isTemplate}
                />
            </div>
        </div>
    );
}